"use client";

import React from "react";
import { MapPin, Phone, Clock, Loader } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableRow } from "@/components/ui/table";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage, FormDescription } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Link } from "@/components/common/Link";
const hoursData = [{
  day: "Segunda-feira",
  time: "08:00 – 12:30 / 14:30 – 19:00"
}, {
  day: "Terça-feira",
  time: "08:00 – 12:30 / 14:30 – 19:00"
}, {
  day: "Quarta-feira",
  time: "08:00 – 12:30 / 14:30 – 19:00"
}, {
  day: "Quinta-feira",
  time: "08:00 – 12:30 / 14:30 – 19:00"
}, {
  day: "Sexta-feira",
  time: "08:00 – 12:30 / 14:30 – 19:00"
}, {
  day: "Sábado",
  time: "08:00 – 12:00"
}, {
  day: "Domingo",
  time: "Encerrado"
}];
function ContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center p-8 bg-primary/10 border border-primary/20 rounded-xl text-center h-full min-h-[400px]">
        <div className="size-16 bg-primary/20 rounded-lg flex items-center justify-center mb-6">
          <Clock className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-bold text-foreground mb-2">Pedido Enviado</h3>
        <p className="text-muted-foreground max-w-md">{successMessage}</p>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-5 bg-card p-6 md:p-8 rounded-xl border border-border shadow-sm">
      <FormField control={control} name="full_name" rules={{
      required: "O nome completo é obrigatório"
    }} render={({
      field
    }) => <FormItem>
            <FormLabel>Nome Completo</FormLabel>
            <FormControl>
              <Input placeholder="João Silva" {...field} />
            </FormControl>
            <FormDescription>Insira o seu nome completo</FormDescription>
            <FormMessage />
          </FormItem>} />

      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        <FormField control={control} name="email" rules={{
        required: "O email é obrigatório",
        pattern: {
          value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
          message: "Endereço de email inválido"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Endereço de Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="joao.silva@example.com" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "O telefone é obrigatório",
        pattern: {
          value: /^\d{2}\s?\d{3}\s?\d{4}$/,
          message: "Formato inválido. Ex: 22 483 6274"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel>Telefone de Contacto</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="22 483 6274" {...field} />
              </FormControl>
              <FormDescription>Formato: 22 483 6274</FormDescription>
              <FormMessage />
            </FormItem>} />
      </div>

      <FormField control={control} name="message" render={({
      field
    }) => <FormItem>
            <FormLabel>Mensagem</FormLabel>
            <FormControl>
              <Textarea placeholder="Alguma observação ou necessidade especial?" className="min-h-[100px] resize-y" {...field} />
            </FormControl>
            <FormMessage />
          </FormItem>} />

      {submitError && <div className="p-3 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-sm text-destructive">{submitError}</p>
        </div>}

      <Button type="submit" variant="secondary" disabled={isSubmitting} className="w-full h-11 text-base shadow-md hover:shadow-lg transition-all">
        {isSubmitting ? <>
            <Loader className="mr-2 size-5 animate-spin" />
            A enviar pedido...
          </> : "Enviar Mensagem"}
      </Button>
    </Form>;
}
export default function AgendeASuaVisita() {
  return <section id="agende-a-sua-visita" className="dark bg-background text-foreground py-20 px-4 md:px-8">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        
        <div className="lg:col-span-7 flex flex-col justify-center">
          <div className="mb-8">
            <h2 className="text-3xl md:text-4xl font-bold tracking-tight text-white mb-4">
              Contacte‑nos
            </h2>
            <p className="text-lg text-muted-foreground">
              Preencha o formulário abaixo com os seus dados e a especialidade pretendida. A nossa equipa entrará em contacto para confirmar a sua marcação.
            </p>
          </div>

          <FormProvider formId="schedule_visit_form_home" sectionName="Contacte‑nos" emailRecipient="clinicasantacruz1@gmail.com" defaultValues={{
          full_name: "",
          email: "",
          phone: "",
          message: ""
        }} validationRules={{
          full_name: {
            required: true
          },
          email: {
            required: true,
            pattern: "email"
          },
          phone: {
            required: true,
            pattern: "^\\d{2}\\s?\\d{3}\\s?\\d{4}$"
          }
        }} submitText="Enviar Mensagem" successMessage="A sua mensagem foi enviada com sucesso. Entraremos em contacto o mais breve possível para confirmar o seu agendamento.">
            <ContactForm />
          </FormProvider>
        </div>

        <div className="lg:col-span-5 space-y-10">
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 xl:grid-cols-2 gap-8">
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-3 rounded-lg shrink-0">
                <MapPin className="size-6 text-secondary" />
              </div>
              <div>
                <h3 className="font-semibold text-lg text-foreground mb-1">Morada</h3>
                <p className="text-muted-foreground leading-relaxed">
                  Largo de Santo António 66<br />
                  1º Andar K<br />
                  4420-307 Gondomar
                </p>
              </div>
            </div>
            <div className="flex items-start gap-4">
              <div className="bg-secondary/10 p-3 rounded-lg shrink-0">
                <Phone className="size-6 text-secondary" />
              </div>
              <div>
                <h3 className="font-semibold text-lg text-foreground mb-1">Telefone</h3>
                <p className="text-muted-foreground text-lg">
                  <Link to="tel:+351224836274" className="hover:text-secondary transition-colors">+351 224 836 274 (custo p/rede fixa)</Link><br />
                  <Link to="tel:+351224836249" className="hover:text-secondary transition-colors">+351 224 836 249 (custo p/rede fixa)</Link><br />
                  <Link to="tel:+351960376019" className="hover:text-secondary transition-colors">+351 960 376 019 (custo p/rede fixa)</Link>
                </p>
              </div>
            </div>
          </div>

          <div>
            <h3 className="font-semibold text-xl text-foreground mb-4 flex items-center gap-2 border-b border-border pb-2">
              <Clock className="size-5 text-primary" />
              Horário de Funcionamento
            </h3>
            <div className="rounded-xl border border-border overflow-hidden bg-card">
              <Table>
                <TableBody>
                  {hoursData.map((h, i) => <TableRow key={i} data-index={i} className="even:bg-muted/30 border-border hover:bg-muted/50 transition-colors">
                      <TableCell className="font-medium py-3 text-foreground">{h.day}</TableCell>
                      <TableCell className="text-right py-3 text-muted-foreground">{h.time}</TableCell>
                    </TableRow>)}
                </TableBody>
              </Table>
            </div>
          </div>

          <div className="rounded-xl overflow-hidden border border-border h-[280px] relative group">
            <div className="absolute inset-0 bg-primary/10 pointer-events-none z-10 transition-opacity group-hover:opacity-0"></div>
            <iframe src="https://maps.google.com/maps?q=Largo%20de%20Santo%20Ant%C3%B3nio%2066%201%C2%BA%20Andar%20K,%204420-307%20Gondomar&t=&z=15&ie=UTF8&iwloc=&output=embed" className="absolute inset-0 w-full h-full border-0 filter grayscale-[20%] contrast-[1.1]" allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade" title="Localização da Clínica Santa Cruz"></iframe>
          </div>

        </div>
      </div>
    </section>;
}